export const UserProfileByUserId = `query userprofilebyuser($userid:ID!) {userprofilebyuser(userid:$userid) {
                userprofileid,
                firstname,
                lastname,
                phonenumber,
                profiletype, 
                avatar                
              }}`;

export const UserByUserId = `
                  query user($userid:ID!){user(userid:$userid) {
                    email
                    ishidebusinessdetails
                    datavisibility
                    role{
                      roleid
                      name
                    }
                  }}`;

export const AddressByUserId = `
                  query addressbyuserid($userid:ID!){addressbyuserid(userid:$userid){
                    addressid,street1,street2,city,stateid,countryid,zip
                  }}
                  `;

export const UpdateUserPinMenu = `mutation UpdateUserPinMenu($userid: ID!, $pinmenus: [MenuInput!]!) {
  updateUserPinMenu(userid: $userid, pinmenus: $pinmenus) {
    userpinmenuid
    userid
    pinmenus {
      moduleid
      menuid
    }
  }
}`;

export const UserPinMenusByUser = `query UserPinMenusByUser($userid: ID!) {
  userPinMenusByUser(userid: $userid) {
    userpinmenuid
    userid
    pinmenus {
      moduleid
      menuid
    }
  }
}`;